import { MapPin } from 'lucide-react';
import { Suspense, lazy } from 'react';

import { cn } from '@/shared/lib/utils';

import { AbrirEnMapasButton } from './abrir-en-mapas-button';

import type { LatLng } from './location-picker-map';

// Mismo mapa Leaflet que el picker, cargado en diferido (fuera del bundle de
// primer paint). Aquí se usa en modo lectura.
const LocationPickerMap = lazy(() => import('./location-picker-map'));

export interface LocationViewerProps {
  value: LatLng;
  /** Alto del contenedor del mapa (clase Tailwind). Default `h-64`. */
  heightClassName?: string;
  className?: string;
}

/**
 * Visor de ubicación de **solo lectura**: muestra el punto en el mapa y permite
 * explorarlo (arrastrar, +/−), pero el marcador es fijo y no edita ni persiste
 * nada. Pensado como pista de contexto (p. ej. el detalle de una incidencia).
 */
export function LocationViewer({
  value,
  heightClassName = 'h-64',
  className,
}: LocationViewerProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <div
        className={cn('w-full overflow-hidden rounded-xl border border-border', heightClassName)}
      >
        <Suspense
          fallback={
            <div className="flex h-full items-center justify-center bg-muted/30 text-xs text-muted-foreground">
              Cargando mapa…
            </div>
          }
        >
          <LocationPickerMap value={value} center={value} recenterTo={null} readOnly />
        </Suspense>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-1.5 text-[11px] text-muted-foreground">
          <MapPin aria-hidden="true" className="size-3.5 text-destructive" />
          <span className="tabular-nums">
            {value.lat.toFixed(6)}, {value.lng.toFixed(6)}
          </span>
        </p>
        <AbrirEnMapasButton value={value} />
      </div>
    </div>
  );
}
